<template>
  <div class="feature-block">
    <div class="feature-block__header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <CIcon
            name="cipInfo"
            size="sm"
            class="mr-2 feature-block__help"
            v-c-tooltip="{
              content: $pgettext('features.photographer_pick', 'Allow photographers to mark their best photos. These selections will be visible to all users as photographer\'s choice.'),
              placement: 'top',
              appendToBody: true
            }"
          />
          <span class="feature-block__title" v-translate translate-context="features.photographer_pick">
            Photographer Pick
          </span>
        </div>
        <CSwitch
          color="primary"
          variant="3d"
          size="sm"
          :checked="localEnabled"
          @update:checked="localEnabled = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturePhotographerPick',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      localEnabled: false
    }
  },
  watch: {
    config: {
      handler() {
        this.reset()
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      this.localEnabled = this.config?.enabled === true
    },
    getConfig() {
      return {
        enabled: this.localEnabled
      }
    }
  }
}
</script>
